import React from 'react';
import { Section } from '@atlaskit/side-navigation';
import { ForgeScreenEvent } from '@atlassian/jira-forge-ui-analytics/src/common/ui/index.tsx';
import { TriggerAnalyticsWrapper } from '@atlassian/jira-forge-ui-analytics/src/ui/admin-page/index.tsx';
import { ADMIN_PAGE_MODULE } from '@atlassian/jira-forge-ui-constants/src/constants.tsx';
import type { AdminPage } from '@atlassian/jira-forge-ui-types/src/common/types/extension.tsx';
import { parseExtensionId } from '@atlassian/jira-forge-ui-utils-internal/src/utils/parse-extension-id/index.tsx';
import { useIntl } from '@atlassian/jira-intl';
import { ForgeItem } from '../../common/ui/forge-item/index.tsx';
import { toSections } from '../../common/utils/subpages/index.tsx';
import { useAdminForgeApps } from '../../controllers/admin/index.tsx';
import { messages } from './messages.tsx';

export const getItemHref = (extension: AdminPage) => {
	const { appId, envId } = parseExtensionId(extension.id);
	return `/jira/settings/apps/${appId}/${envId}`;
};

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const ForgeAdminSection: Flow.AbstractComponent<Record<any, any>> = () => {
	const { formatMessage } = useIntl();
	const { data } = useAdminForgeApps();
	const pages: AdminPage[] | null = data?.adminPage ?? null;

	if (!pages?.length) return null;

	return (
		<Section title={formatMessage(messages.forgeSectionTitle)}>
			{pages.map((extension) => (
				<ForgeItem
					key={extension.id}
					id={extension.id}
					environmentType={extension.environmentType}
					environmentKey={extension.environmentKey}
					url={getItemHref(extension)}
					name={extension.properties.title}
					sections={toSections(extension)}
					moduleName={ADMIN_PAGE_MODULE}
					iconUrl={extension.properties.icon}
					showIcon
				/>
			))}
			<ForgeScreenEvent
				attributes={{
					moduleType: ADMIN_PAGE_MODULE,
				}}
			/>
		</Section>
	);
};

// eslint-disable-next-line jira/import/no-anonymous-default-export
export default () => (
	<TriggerAnalyticsWrapper>
		<ForgeAdminSection />
	</TriggerAnalyticsWrapper>
);
